// credit: https://stackoverflow.com/a/51398471/7562739

import { call, put } from 'redux-saga/effects'
import {
  __setAiSubscription,
  PaddleSubscriptionApiResponse,
  setAiSubscriptionError,
  setAiSubscriptionLoading,
  SetAiSubscriptionPayload,
} from 'store/slices/subscription/subscription'

// for put effect PutEffect<PayloadAction<CopyResponse>> can be used and import be like ---> import { AnyAction } from 'redux';
type WhatYouYield = Promise<void> | { payload: any; type: string }
type WhatYouReturn = void

type WhatYouAcceptFromAPI = PaddleSubscriptionApiResponse

export function* handleFetchAiSubscription(action: {
  payload: SetAiSubscriptionPayload
}): Generator<WhatYouYield, WhatYouReturn, WhatYouAcceptFromAPI> {
  try {
    const { uid } = action.payload

    // Set loading state
    yield put(setAiSubscriptionLoading(true))

    // Fetch real-time subscription status from Paddle API
    const response = yield call(async () => {
      const res = await fetch(`/api/subscriptions/status?uid=${uid}`)
      return res.json()
    })

    // Check for API errors
    if (response.error) {
      throw new Error(response.message || 'Failed to fetch subscription status')
    }

    // Update subscription data in Redux store
    yield put(__setAiSubscription(response))
  } catch (error) {
    console.error('Subscription fetch error:', error)

    yield put(
      setAiSubscriptionError(
        error instanceof Error
          ? error.message
          : "Couldn't fetch subscription status. Please try again. If the problem persists, please contact support@typingmentor.com."
      )
    )
  }
}

export {}
